import React, { useContext } from "react";
import ProjectContext from "../../Contexts/ProjectContext";

export default function SkillsSection() {
  const contextData = useContext(ProjectContext);

  return (
    <section
      id="skills"
      className={`py-10 md:py-[60px] ${
        contextData.language === "EN" ? "ltr" : "rtl"
      }`}
    >
      <div className="container">
        <div>
          {contextData.language === "EN" ? (
            <h2 className="font-SoraRegular text-4xl/5 md:text-5xl/[56px] text-center tracking-tighter mb-10">
              My <span className="font-SoraExtraBold ml-4">Skills</span>
            </h2>
          ) : (
            <h2 className="font-MorabbaBold text-4xl/5 md:text-5xl/[56px] text-center tracking-tighter mb-10">
              مهارت های <span className="font-MorabbaMedium ml-4">من</span>
            </h2>
          )}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 justify-items-center md:justify-items-start gap-x-2 md:gap-x-[72px] gap-y-5 md:gap-y-10">
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-green-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  width="56"
                  height="56"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 128 128"
                >
                  <path
                    fill="#000"
                    d="M9.032 2l10.005 112.093 44.896 12.401 45.02-12.387L118.968 2H9.032zm89.126 26.539l-.627 7.172L97.255 39H44.59l1.257 14h50.156l-.336 3.471-3.233 36.119-.238 2.27L64 102.609v.002l-.034.018-28.177-7.423L33.876 74h13.815l.979 10.919L63.957 89H64v-.546l15.355-3.875L80.959 67H33.261l-3.383-38.117L29.549 25h68.939l-.33 3.539z"
                  />
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  width="56"
                  height="56"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 128 128"
                >
                  <path
                    fill="#fff"
                    d="M9.032 2l10.005 112.093 44.896 12.401 45.02-12.387L118.968 2H9.032zm89.126 26.539l-.627 7.172L97.255 39H44.59l1.257 14h50.156l-.336 3.471-3.233 36.119-.238 2.27L64 102.609v.002l-.034.018-28.177-7.423L33.876 74h13.815l.979 10.919L63.957 89H64v-.546l15.355-3.875L80.959 67H33.261l-3.383-38.117L29.549 25h68.939l-.33 3.539z"
                  />
                </svg>
              </div>
              <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                HTML5
              </span>
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-green-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  width="56"
                  height="56"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 128 128"
                >
                  <path
                    fill="#000"
                    d="M8.76 1l10.055 112.883 45.118 12.58 45.244-12.626L119.24 1H8.76zm89.591 25.862l-3.347 37.605.01.203-.014.467v-.004l-2.378 26.294-.262 2.336L64 101.607v.001l-.022.019-28.311-7.888L33.75 72h13.883l.985 11.054 15.386 4.17-.004.008v-.002l15.443-4.229L81.075 65H48.792l-.277-3.043-.631-7.129L47.553 51h34.749l1.264-14H30.64l-.277-3.041-.63-7.131L29.401 23h69.281l-.331 3.862z"
                  />
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  width="56"
                  height="56"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 128 128"
                >
                  <path
                    fill="#fff"
                    d="M8.76 1l10.055 112.883 45.118 12.58 45.244-12.626L119.24 1H8.76zm89.591 25.862l-3.347 37.605.01.203-.014.467v-.004l-2.378 26.294-.262 2.336L64 101.607v.001l-.022.019-28.311-7.888L33.75 72h13.883l.985 11.054 15.386 4.17-.004.008v-.002l15.443-4.229L81.075 65H48.792l-.277-3.043-.631-7.129L47.553 51h34.749l1.264-14H30.64l-.277-3.041-.63-7.131L29.401 23h69.281l-.331 3.862z"
                  />
                </svg>
              </div>
              <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                CSS3
              </span>
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-green-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 56V0H56V56H0Z" fill="black" />
                  <path
                    d="M36.6147 41.9176C37.6912 43.666 38.861 45.3414 41.339 45.3414C43.4203 45.3414 44.5123 44.3069 44.5123 42.8758C44.5123 41.1631 43.383 40.5549 41.0932 39.5578L39.8378 39.0227C36.215 37.4858 33.8054 35.56 33.8054 31.4923C33.8054 27.7434 36.6754 24.8905 41.1601 24.8905C44.3536 24.8905 46.6481 25.9965 48.3032 28.8929L44.3925 31.3927C43.5323 29.8558 42.6021 29.2507 41.1601 29.2507C39.6885 29.2507 38.7567 30.1794 38.7567 31.3927C38.7567 32.8922 39.6901 33.4989 41.8445 34.4276L43.0998 34.9627C47.3698 36.7811 49.7778 38.6385 49.7778 42.8136C49.7778 47.3122 46.225 49.7778 41.4556 49.7778C36.7905 49.7778 34.1414 47.4367 32.6667 44.5387L36.6147 41.9176ZM18.5921 42.0451C19.3792 43.4545 20.5754 44.5387 22.2958 44.5387C23.9416 44.5387 24.889 43.8885 24.889 41.3607V24.8889H30.0736V42.1571C30.0736 47.3947 27.0356 49.7778 22.5992 49.7778C18.5905 49.7778 15.6972 47.0618 14.5181 44.5387L18.5921 42.0451Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 56V0H56V56H0Z" fill="white" />
                  <path
                    d="M36.6147 41.9176C37.6912 43.666 38.861 45.3414 41.339 45.3414C43.4203 45.3414 44.5123 44.3069 44.5123 42.8758C44.5123 41.1631 43.383 40.5549 41.0932 39.5578L39.8378 39.0227C36.215 37.4858 33.8054 35.56 33.8054 31.4923C33.8054 27.7434 36.6754 24.8905 41.1601 24.8905C44.3536 24.8905 46.6481 25.9965 48.3032 28.8929L44.3925 31.3927C43.5323 29.8558 42.6021 29.2507 41.1601 29.2507C39.6885 29.2507 38.7567 30.1794 38.7567 31.3927C38.7567 32.8922 39.6901 33.4989 41.8445 34.4276L43.0998 34.9627C47.3698 36.7811 49.7778 38.6385 49.7778 42.8136C49.7778 47.3122 46.225 49.7778 41.4556 49.7778C36.7905 49.7778 34.1414 47.4367 32.6667 44.5387L36.6147 41.9176ZM18.5921 42.0451C19.3792 43.4545 20.5754 44.5387 22.2958 44.5387C23.9416 44.5387 24.889 43.8885 24.889 41.3607V24.8889H30.0736V42.1571C30.0736 47.3947 27.0356 49.7778 22.5992 49.7778C18.5905 49.7778 15.6972 47.0618 14.5181 44.5387L18.5921 42.0451Z"
                    fill="black"
                  />
                </svg>
              </div>
              <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                javascript
              </span>
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-green-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  width="62"
                  height="56"
                  viewBox="0 0 62 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_513)">
                    <path
                      d="M31.2933 33.9258C34.5066 33.9258 37.1115 31.2727 37.1115 27.9999C37.1115 24.7271 34.5066 22.074 31.2933 22.074C28.08 22.074 25.4751 24.7271 25.4751 27.9999C25.4751 31.2727 28.08 33.9258 31.2933 33.9258Z"
                      fill="black"
                    />
                    <path
                      d="M31.2933 41.3334C47.3598 41.3334 60.3842 35.3639 60.3842 28.0001C60.3842 20.6363 47.3598 14.6667 31.2933 14.6667C15.2268 14.6667 2.20239 20.6363 2.20239 28.0001C2.20239 35.3639 15.2268 41.3334 31.2933 41.3334Z"
                      stroke="black"
                      strokeWidth="3"
                    />
                    <path
                      d="M19.9563 34.6667C27.9895 48.8383 39.5775 57.3419 45.8388 53.66C52.1001 49.9781 50.6637 35.505 42.6304 21.3334C34.5972 7.16172 23.0092 -1.34189 16.7479 2.34001C10.4866 6.02191 11.9231 20.4951 19.9563 34.6667Z"
                      stroke="black"
                      strokeWidth="3"
                    />
                    <path
                      d="M19.9562 21.3333C11.923 35.5049 10.4865 49.978 16.7478 53.6599C23.0091 57.3418 34.5971 48.8382 42.6303 34.6666C50.6636 20.495 52.1 6.02182 45.8387 2.33992C39.5774 -1.34197 27.9894 7.16164 19.9562 21.3333Z"
                      stroke="black"
                      strokeWidth="3"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_196_513">
                      <rect
                        width="61.0909"
                        height="56"
                        fill="white"
                        transform="translate(0.747803)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  width="62"
                  height="56"
                  viewBox="0 0 62 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_513)">
                    <path
                      d="M31.2933 33.9258C34.5066 33.9258 37.1115 31.2727 37.1115 27.9999C37.1115 24.7271 34.5066 22.074 31.2933 22.074C28.08 22.074 25.4751 24.7271 25.4751 27.9999C25.4751 31.2727 28.08 33.9258 31.2933 33.9258Z"
                      fill="white"
                    />
                    <path
                      d="M31.2933 41.3334C47.3598 41.3334 60.3842 35.3639 60.3842 28.0001C60.3842 20.6363 47.3598 14.6667 31.2933 14.6667C15.2268 14.6667 2.20239 20.6363 2.20239 28.0001C2.20239 35.3639 15.2268 41.3334 31.2933 41.3334Z"
                      stroke="white"
                      strokeWidth="3"
                    />
                    <path
                      d="M19.9563 34.6667C27.9895 48.8383 39.5775 57.3419 45.8388 53.66C52.1001 49.9781 50.6637 35.505 42.6304 21.3334C34.5972 7.16172 23.0092 -1.34189 16.7479 2.34001C10.4866 6.02191 11.9231 20.4951 19.9563 34.6667Z"
                      stroke="white"
                      strokeWidth="3"
                    />
                    <path
                      d="M19.9562 21.3333C11.923 35.5049 10.4865 49.978 16.7478 53.6599C23.0091 57.3418 34.5971 48.8382 42.6303 34.6666C50.6636 20.495 52.1 6.02182 45.8387 2.33992C39.5774 -1.34197 27.9894 7.16164 19.9562 21.3333Z"
                      stroke="white"
                      strokeWidth="3"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_196_513">
                      <rect
                        width="61.0909"
                        height="56"
                        fill="white"
                        transform="translate(0.747803)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                React
              </span>
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-green-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  width="93"
                  height="56"
                  viewBox="0 0 93 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_521)">
                    <mask
                      id="mask0_196_521"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="93"
                      height="55"
                    >
                      <path
                        d="M0.974121 0H92.6105V54.9818H0.974121V0Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_196_521)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M46.7923 0C34.5741 0 26.9378 6.10909 23.8832 18.3273C28.465 12.2182 33.8105 9.92727 39.9196 11.4545C43.4052 12.3251 45.8963 14.8553 48.6539 17.6536C53.1458 22.2133 58.3453 27.4909 69.7014 27.4909C81.9196 27.4909 89.5559 21.3818 92.6105 9.16364C88.0287 15.2727 82.6832 17.5636 76.5741 16.0364C73.0885 15.1658 70.5974 12.6356 67.8398 9.83733C63.3479 5.27758 58.1484 0 46.7923 0ZM23.8832 27.4909C11.665 27.4909 4.02867 33.6 0.974121 45.8182C5.55594 39.7091 10.9014 37.4182 17.0105 38.9455C20.4961 39.8177 22.9872 42.3462 25.7448 45.1445C30.2367 49.7042 35.4362 54.9818 46.7923 54.9818C59.0105 54.9818 66.6468 48.8727 69.7014 36.6545C65.1196 42.7636 59.7741 45.0545 53.665 43.5273C50.1795 42.6567 47.6883 40.1265 44.9307 37.3282C40.4388 32.7685 35.2393 27.4909 23.8832 27.4909Z"
                        fill="black"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_196_521">
                      <rect
                        width="91.6364"
                        height="56"
                        fill="white"
                        transform="translate(0.974121)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  width="93"
                  height="56"
                  viewBox="0 0 93 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_521)">
                    <mask
                      id="mask0_196_521"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="93"
                      height="55"
                    >
                      <path
                        d="M0.974121 0H92.6105V54.9818H0.974121V0Z"
                        fill="black"
                      />
                    </mask>
                    <g mask="url(#mask0_196_521)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M46.7923 0C34.5741 0 26.9378 6.10909 23.8832 18.3273C28.465 12.2182 33.8105 9.92727 39.9196 11.4545C43.4052 12.3251 45.8963 14.8553 48.6539 17.6536C53.1458 22.2133 58.3453 27.4909 69.7014 27.4909C81.9196 27.4909 89.5559 21.3818 92.6105 9.16364C88.0287 15.2727 82.6832 17.5636 76.5741 16.0364C73.0885 15.1658 70.5974 12.6356 67.8398 9.83733C63.3479 5.27758 58.1484 0 46.7923 0ZM23.8832 27.4909C11.665 27.4909 4.02867 33.6 0.974121 45.8182C5.55594 39.7091 10.9014 37.4182 17.0105 38.9455C20.4961 39.8177 22.9872 42.3462 25.7448 45.1445C30.2367 49.7042 35.4362 54.9818 46.7923 54.9818C59.0105 54.9818 66.6468 48.8727 69.7014 36.6545C65.1196 42.7636 59.7741 45.0545 53.665 43.5273C50.1795 42.6567 47.6883 40.1265 44.9307 37.3282C40.4388 32.7685 35.2393 27.4909 23.8832 27.4909Z"
                        fill="white"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_196_521">
                      <rect
                        width="91.6364"
                        height="56"
                        fill="black"
                        transform="translate(0.974121)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                Tailwind
              </span>
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-green-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  width="39"
                  height="56"
                  viewBox="0 0 39 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_522)">
                    <path
                      d="M18.3594 27.9998C18.3594 25.5245 19.3427 23.1505 21.093 21.4002C22.8434 19.6498 25.2174 18.6665 27.6927 18.6665C30.1681 18.6665 32.542 19.6498 34.2924 21.4002C36.0427 23.1505 37.026 25.5245 37.026 27.9998C37.026 30.4752 36.0427 32.8492 34.2924 34.5995C32.542 36.3498 30.1681 37.3332 27.6927 37.3332C25.2174 37.3332 22.8434 36.3498 21.093 34.5995C19.3427 32.8492 18.3594 30.4752 18.3594 27.9998Z"
                      fill="black"
                    />
                    <path
                      d="M1.19263 46.6666C1.19263 44.3238 2.12328 42.077 3.77985 40.4205C5.43642 38.7639 7.68322 37.8333 10.026 37.8333H18.8593V46.6666C18.8593 49.0093 17.9286 51.2561 16.2721 52.9127C14.6155 54.5693 12.3687 55.4999 10.026 55.4999C7.68322 55.4999 5.43642 54.5693 3.77985 52.9127C2.12328 51.2561 1.19263 49.0093 1.19263 46.6666Z"
                      fill="black"
                      stroke="black"
                    />
                    <path
                      d="M26.6927 18.1667H17.8594V0.5H26.6927C29.0355 0.5 31.2822 1.43065 32.9388 3.08722C34.5954 4.74379 35.526 6.99059 35.526 9.33333C35.526 11.6761 34.5954 13.9229 32.9388 15.5794C31.2822 17.236 29.0355 18.1667 26.6927 18.1667Z"
                      stroke="black"
                    />
                    <path
                      d="M0.692627 9.33333C0.692627 11.8087 1.67596 14.1827 3.4263 15.933C5.17664 17.6833 7.55061 18.6667 10.026 18.6667H19.3593V0H10.026C7.55061 0 5.17664 0.98333 3.4263 2.73367C1.67596 4.48401 0.692627 6.85798 0.692627 9.33333Z"
                      fill="black"
                    />
                    <path
                      d="M3.77985 34.2462C2.12328 32.5896 1.19263 30.3428 1.19263 28.0001C1.19263 25.6573 2.12328 23.4105 3.77985 21.754C5.43642 20.0974 7.68322 19.1667 10.026 19.1667H18.8593V36.8334H10.026C7.68322 36.8334 5.43642 35.9028 3.77985 34.2462Z"
                      stroke="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_196_522">
                      <rect
                        width="37.3333"
                        height="56"
                        fill="white"
                        transform="translate(0.692627)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  width="39"
                  height="56"
                  viewBox="0 0 39 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_522)">
                    <path
                      d="M18.3594 27.9998C18.3594 25.5245 19.3427 23.1505 21.093 21.4002C22.8434 19.6498 25.2174 18.6665 27.6927 18.6665C30.1681 18.6665 32.542 19.6498 34.2924 21.4002C36.0427 23.1505 37.026 25.5245 37.026 27.9998C37.026 30.4752 36.0427 32.8492 34.2924 34.5995C32.542 36.3498 30.1681 37.3332 27.6927 37.3332C25.2174 37.3332 22.8434 36.3498 21.093 34.5995C19.3427 32.8492 18.3594 30.4752 18.3594 27.9998Z"
                      fill="white"
                    />
                    <path
                      d="M1.19263 46.6666C1.19263 44.3238 2.12328 42.077 3.77985 40.4205C5.43642 38.7639 7.68322 37.8333 10.026 37.8333H18.8593V46.6666C18.8593 49.0093 17.9286 51.2561 16.2721 52.9127C14.6155 54.5693 12.3687 55.4999 10.026 55.4999C7.68322 55.4999 5.43642 54.5693 3.77985 52.9127C2.12328 51.2561 1.19263 49.0093 1.19263 46.6666Z"
                      fill="white"
                      stroke="white"
                    />
                    <path
                      d="M26.6927 18.1667H17.8594V0.5H26.6927C29.0355 0.5 31.2822 1.43065 32.9388 3.08722C34.5954 4.74379 35.526 6.99059 35.526 9.33333C35.526 11.6761 34.5954 13.9229 32.9388 15.5794C31.2822 17.236 29.0355 18.1667 26.6927 18.1667Z"
                      stroke="white"
                    />
                    <path
                      d="M0.692627 9.33333C0.692627 11.8087 1.67596 14.1827 3.4263 15.933C5.17664 17.6833 7.55061 18.6667 10.026 18.6667H19.3593V0H10.026C7.55061 0 5.17664 0.98333 3.4263 2.73367C1.67596 4.48401 0.692627 6.85798 0.692627 9.33333Z"
                      fill="white"
                    />
                    <path
                      d="M3.77985 34.2462C2.12328 32.5896 1.19263 30.3428 1.19263 28.0001C1.19263 25.6573 2.12328 23.4105 3.77985 21.754C5.43642 20.0974 7.68322 19.1667 10.026 19.1667H18.8593V36.8334H10.026C7.68322 36.8334 5.43642 35.9028 3.77985 34.2462Z"
                      stroke="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_196_522">
                      <rect
                        width="37.3333"
                        height="56"
                        fill="white"
                        transform="translate(0.692627)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                Figma
              </span>
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-green-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M49.2333 25.7833L30.2166 6.76659C29.6333 6.18325 28.8166 5.83325 27.9999 5.83325C27.1833 5.83325 26.3666 6.18325 25.7833 6.76659L21.6999 10.8499L26.4833 15.6333C26.9499 15.3999 27.4166 15.2833 27.9999 15.2833C29.9833 15.2833 31.4999 16.7999 31.4999 18.7833C31.4999 19.3666 31.3833 19.8333 31.1499 20.2999L35.8166 24.9666C36.2833 24.7333 36.7499 24.6166 37.3333 24.6166C39.3166 24.6166 40.8333 26.1333 40.8333 28.1166C40.8333 30.0999 39.3166 31.6166 37.3333 31.6166C35.3499 31.6166 33.8333 30.0999 33.8333 28.1166C33.8333 27.5333 33.9499 27.0666 34.1833 26.5999L29.5166 21.9333C29.3999 21.9333 29.2833 22.0499 29.1666 22.0499V34.1833C30.5666 34.6499 31.4999 35.9333 31.4999 37.4499C31.4999 39.4333 29.9833 40.9499 27.9999 40.9499C26.0166 40.9499 24.4999 39.4333 24.4999 37.4499C24.4999 35.9333 25.4333 34.6499 26.8333 34.1833V21.9333C25.4333 21.4666 24.4999 20.1833 24.4999 18.6666C24.4999 18.0833 24.6166 17.6166 24.8499 17.1499L20.0666 12.3666L6.76659 25.7833C6.18325 26.3666 5.83325 27.1833 5.83325 27.9999C5.83325 28.8166 6.18325 29.6333 6.76659 30.2166L25.7833 49.2333C26.3666 49.8166 27.1833 50.1666 27.9999 50.1666C28.8166 50.1666 29.6333 49.8166 30.2166 49.2333L49.2333 30.2166C49.8166 29.6333 50.1666 28.8166 50.1666 27.9999C50.1666 27.1833 49.8166 26.3666 49.2333 25.7833Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M49.2333 25.7833L30.2166 6.76659C29.6333 6.18325 28.8166 5.83325 27.9999 5.83325C27.1833 5.83325 26.3666 6.18325 25.7833 6.76659L21.6999 10.8499L26.4833 15.6333C26.9499 15.3999 27.4166 15.2833 27.9999 15.2833C29.9833 15.2833 31.4999 16.7999 31.4999 18.7833C31.4999 19.3666 31.3833 19.8333 31.1499 20.2999L35.8166 24.9666C36.2833 24.7333 36.7499 24.6166 37.3333 24.6166C39.3166 24.6166 40.8333 26.1333 40.8333 28.1166C40.8333 30.0999 39.3166 31.6166 37.3333 31.6166C35.3499 31.6166 33.8333 30.0999 33.8333 28.1166C33.8333 27.5333 33.9499 27.0666 34.1833 26.5999L29.5166 21.9333C29.3999 21.9333 29.2833 22.0499 29.1666 22.0499V34.1833C30.5666 34.6499 31.4999 35.9333 31.4999 37.4499C31.4999 39.4333 29.9833 40.9499 27.9999 40.9499C26.0166 40.9499 24.4999 39.4333 24.4999 37.4499C24.4999 35.9333 25.4333 34.6499 26.8333 34.1833V21.9333C25.4333 21.4666 24.4999 20.1833 24.4999 18.6666C24.4999 18.0833 24.6166 17.6166 24.8499 17.1499L20.0666 12.3666L6.76659 25.7833C6.18325 26.3666 5.83325 27.1833 5.83325 27.9999C5.83325 28.8166 6.18325 29.6333 6.76659 30.2166L25.7833 49.2333C26.3666 49.8166 27.1833 50.1666 27.9999 50.1666C28.8166 50.1666 29.6333 49.8166 30.2166 49.2333L49.2333 30.2166C49.8166 29.6333 50.1666 28.8166 50.1666 27.9999C50.1666 27.1833 49.8166 26.3666 49.2333 25.7833Z"
                    fill="white"
                  />
                </svg>
              </div>
              <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                Git & Github
              </span>
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-rose-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  height="56px"
                  viewBox=".5 -.2 1023 1024.1"
                  width="56px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m478.5.6c-2.2.2-9.2.9-15.5 1.4-145.3 13.1-281.4 91.5-367.6 212-48 67-78.7 143-90.3 223.5-4.1 28.1-4.6 36.4-4.6 74.5s.5 46.4 4.6 74.5c27.8 192.1 164.5 353.5 349.9 413.3 33.2 10.7 68.2 18 108 22.4 15.5 1.7 82.5 1.7 98 0 68.7-7.6 126.9-24.6 184.3-53.9 8.8-4.5 10.5-5.7 9.3-6.7-.8-.6-38.3-50.9-83.3-111.7l-81.8-110.5-102.5-151.7c-56.4-83.4-102.8-151.6-103.2-151.6-.4-.1-.8 67.3-1 149.6-.3 144.1-.4 149.9-2.2 153.3-2.6 4.9-4.6 6.9-8.8 9.1-3.2 1.6-6 1.9-21.1 1.9h-17.3l-4.6-2.9c-3-1.9-5.2-4.4-6.7-7.3l-2.1-4.5.2-200.5.3-200.6 3.1-3.9c1.6-2.1 5-4.8 7.4-6.1 4.1-2 5.7-2.2 23-2.2 20.4 0 23.8.8 29.1 6.6 1.5 1.6 57 85.2 123.4 185.9s157.2 238.2 201.8 305.7l81 122.7 4.1-2.7c36.3-23.6 74.7-57.2 105.1-92.2 64.7-74.3 106.4-164.9 120.4-261.5 4.1-28.1 4.6-36.4 4.6-74.5s-.5-46.4-4.6-74.5c-27.8-192.1-164.5-353.5-349.9-413.3-32.7-10.6-67.5-17.9-106.5-22.3-9.6-1-75.7-2.1-84-1.3zm209.4 309.4c4.8 2.4 8.7 7 10.1 11.8.8 2.6 1 58.2.8 183.5l-.3 179.8-31.7-48.6-31.8-48.6v-130.7c0-84.5.4-132 1-134.3 1.6-5.6 5.1-10 9.9-12.6 4.1-2.1 5.6-2.3 21.3-2.3 14.8 0 17.4.2 20.7 2z" />
                  <path d="m784.3 945.1c-3.5 2.2-4.6 3.7-1.5 2 2.2-1.3 5.8-4 5.2-4.1-.3 0-2 1-3.7 2.1zm-6.9 4.5c-1.8 1.4-1.8 1.5.4.4 1.2-.6 2.2-1.3 2.2-1.5 0-.8-.5-.6-2.6 1.1zm-5 3c-1.8 1.4-1.8 1.5.4.4 1.2-.6 2.2-1.3 2.2-1.5 0-.8-.5-.6-2.6 1.1zm-5 3c-1.8 1.4-1.8 1.5.4.4 1.2-.6 2.2-1.3 2.2-1.5 0-.8-.5-.6-2.6 1.1zm-7.6 4c-3.8 2-3.6 2.8.2.9 1.7-.9 3-1.8 3-2 0-.7-.1-.6-3.2 1.1z" />
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  className="group-hover:fill-white"
                  height="56px"
                  viewBox=".5 -.2 1023 1024.1"
                  width="56px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m478.5.6c-2.2.2-9.2.9-15.5 1.4-145.3 13.1-281.4 91.5-367.6 212-48 67-78.7 143-90.3 223.5-4.1 28.1-4.6 36.4-4.6 74.5s.5 46.4 4.6 74.5c27.8 192.1 164.5 353.5 349.9 413.3 33.2 10.7 68.2 18 108 22.4 15.5 1.7 82.5 1.7 98 0 68.7-7.6 126.9-24.6 184.3-53.9 8.8-4.5 10.5-5.7 9.3-6.7-.8-.6-38.3-50.9-83.3-111.7l-81.8-110.5-102.5-151.7c-56.4-83.4-102.8-151.6-103.2-151.6-.4-.1-.8 67.3-1 149.6-.3 144.1-.4 149.9-2.2 153.3-2.6 4.9-4.6 6.9-8.8 9.1-3.2 1.6-6 1.9-21.1 1.9h-17.3l-4.6-2.9c-3-1.9-5.2-4.4-6.7-7.3l-2.1-4.5.2-200.5.3-200.6 3.1-3.9c1.6-2.1 5-4.8 7.4-6.1 4.1-2 5.7-2.2 23-2.2 20.4 0 23.8.8 29.1 6.6 1.5 1.6 57 85.2 123.4 185.9s157.2 238.2 201.8 305.7l81 122.7 4.1-2.7c36.3-23.6 74.7-57.2 105.1-92.2 64.7-74.3 106.4-164.9 120.4-261.5 4.1-28.1 4.6-36.4 4.6-74.5s-.5-46.4-4.6-74.5c-27.8-192.1-164.5-353.5-349.9-413.3-32.7-10.6-67.5-17.9-106.5-22.3-9.6-1-75.7-2.1-84-1.3zm209.4 309.4c4.8 2.4 8.7 7 10.1 11.8.8 2.6 1 58.2.8 183.5l-.3 179.8-31.7-48.6-31.8-48.6v-130.7c0-84.5.4-132 1-134.3 1.6-5.6 5.1-10 9.9-12.6 4.1-2.1 5.6-2.3 21.3-2.3 14.8 0 17.4.2 20.7 2z" />
                  <path d="m784.3 945.1c-3.5 2.2-4.6 3.7-1.5 2 2.2-1.3 5.8-4 5.2-4.1-.3 0-2 1-3.7 2.1zm-6.9 4.5c-1.8 1.4-1.8 1.5.4.4 1.2-.6 2.2-1.3 2.2-1.5 0-.8-.5-.6-2.6 1.1zm-5 3c-1.8 1.4-1.8 1.5.4.4 1.2-.6 2.2-1.3 2.2-1.5 0-.8-.5-.6-2.6 1.1zm-5 3c-1.8 1.4-1.8 1.5.4.4 1.2-.6 2.2-1.3 2.2-1.5 0-.8-.5-.6-2.6 1.1zm-7.6 4c-3.8 2-3.6 2.8.2.9 1.7-.9 3-1.8 3-2 0-.7-.1-.6-3.2 1.1z" />
                </svg>
              </div>
              {contextData.language === "EN" ? (
                <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                  Learning...
                </span>
              ) : (
                <span className="font-DanaDemiBold text-center text-lg group-hover:text-white">
                  در حال یادگیری
                </span>
              )}
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-rose-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  width="50"
                  height="56"
                  viewBox="0 0 50 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_514)">
                    <path
                      d="M25.3808 55.9999C24.6301 55.9999 23.9294 55.7958 23.2787 55.4386L16.6223 51.4076C15.6214 50.8463 16.1218 50.6423 16.4222 50.5402C17.7735 50.081 18.0237 49.9789 19.4251 49.1625C19.5752 49.0604 19.7754 49.1115 19.9255 49.2135L25.0304 52.3261C25.2307 52.4282 25.4809 52.4282 25.631 52.3261L45.6002 40.5392C45.8004 40.4371 45.9005 40.2331 45.9005 39.9779V16.4552C45.9005 16.2001 45.8004 15.996 45.6002 15.8939L25.631 4.15808C25.4308 4.05603 25.1805 4.05603 25.0304 4.15808L5.06122 15.8939C4.86103 15.996 4.76093 16.2511 4.76093 16.4552V39.9779C4.76093 40.182 4.86103 40.4371 5.06122 40.5392L10.5165 43.7538C13.4693 45.2845 15.3211 43.4987 15.3211 41.7128V18.4962C15.3211 18.19 15.5714 17.884 15.9217 17.884H18.4742C18.7744 17.884 19.0747 18.1391 19.0747 18.4962V41.7128C19.0747 45.7438 16.9226 48.091 13.169 48.091C12.0179 48.091 11.1171 48.091 8.56457 46.8153L3.30954 43.7538C2.00829 42.9884 1.20752 41.5597 1.20752 40.029V16.5062C1.20752 14.9755 2.00829 13.5468 3.30954 12.7814L23.2787 0.994506C24.53 0.280152 26.2316 0.280152 27.4828 0.994506L47.452 12.7814C48.7533 13.5468 49.554 14.9755 49.554 16.5062V40.029C49.554 41.5597 48.7533 42.9884 47.452 43.7538L27.4828 55.5407C26.8822 55.7958 26.1315 55.9999 25.3808 55.9999Z"
                      fill="black"
                    />
                    <path
                      d="M31.5868 39.8249C22.8283 39.8249 21.0266 35.7429 21.0266 32.2732C21.0266 31.9671 21.2768 31.6609 21.6271 31.6609H24.2297C24.5299 31.6609 24.7802 31.865 24.7802 32.1712C25.1806 34.8755 26.3317 36.2022 31.6368 36.2022C35.8408 36.2022 37.6426 35.2327 37.6426 32.9365C37.6426 31.6099 37.1421 30.6404 30.5858 29.977C25.1305 29.4157 21.7273 28.1912 21.7273 23.7519C21.7273 19.6189 25.1305 17.1697 30.836 17.1697C37.2422 17.1697 40.3952 19.4148 40.7956 24.3132C40.7956 24.4663 40.7456 24.6194 40.6455 24.7725C40.5454 24.8745 40.3952 24.9766 40.2451 24.9766H37.5925C37.3422 24.9766 37.092 24.7725 37.042 24.5173C36.4414 21.7109 34.8899 20.7925 30.786 20.7925C26.1815 20.7925 25.631 22.4253 25.631 23.6499C25.631 25.1296 26.2817 25.5889 32.4876 26.4053C38.6435 27.2217 41.5463 28.3953 41.5463 32.7835C41.5463 37.2737 37.8928 39.8249 31.5868 39.8249Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_196_514">
                      <rect
                        width="49.28"
                        height="56"
                        fill="white"
                        transform="translate(0.653809)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  width="50"
                  height="56"
                  viewBox="0 0 50 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_514)">
                    <path
                      d="M25.3808 55.9999C24.6301 55.9999 23.9294 55.7958 23.2787 55.4386L16.6223 51.4076C15.6214 50.8463 16.1218 50.6423 16.4222 50.5402C17.7735 50.081 18.0237 49.9789 19.4251 49.1625C19.5752 49.0604 19.7754 49.1115 19.9255 49.2135L25.0304 52.3261C25.2307 52.4282 25.4809 52.4282 25.631 52.3261L45.6002 40.5392C45.8004 40.4371 45.9005 40.2331 45.9005 39.9779V16.4552C45.9005 16.2001 45.8004 15.996 45.6002 15.8939L25.631 4.15808C25.4308 4.05603 25.1805 4.05603 25.0304 4.15808L5.06122 15.8939C4.86103 15.996 4.76093 16.2511 4.76093 16.4552V39.9779C4.76093 40.182 4.86103 40.4371 5.06122 40.5392L10.5165 43.7538C13.4693 45.2845 15.3211 43.4987 15.3211 41.7128V18.4962C15.3211 18.19 15.5714 17.884 15.9217 17.884H18.4742C18.7744 17.884 19.0747 18.1391 19.0747 18.4962V41.7128C19.0747 45.7438 16.9226 48.091 13.169 48.091C12.0179 48.091 11.1171 48.091 8.56457 46.8153L3.30954 43.7538C2.00829 42.9884 1.20752 41.5597 1.20752 40.029V16.5062C1.20752 14.9755 2.00829 13.5468 3.30954 12.7814L23.2787 0.994506C24.53 0.280152 26.2316 0.280152 27.4828 0.994506L47.452 12.7814C48.7533 13.5468 49.554 14.9755 49.554 16.5062V40.029C49.554 41.5597 48.7533 42.9884 47.452 43.7538L27.4828 55.5407C26.8822 55.7958 26.1315 55.9999 25.3808 55.9999Z"
                      fill="white"
                    />
                    <path
                      d="M31.5868 39.8249C22.8283 39.8249 21.0266 35.7429 21.0266 32.2732C21.0266 31.9671 21.2768 31.6609 21.6271 31.6609H24.2297C24.5299 31.6609 24.7802 31.865 24.7802 32.1712C25.1806 34.8755 26.3317 36.2022 31.6368 36.2022C35.8408 36.2022 37.6426 35.2327 37.6426 32.9365C37.6426 31.6099 37.1421 30.6404 30.5858 29.977C25.1305 29.4157 21.7273 28.1912 21.7273 23.7519C21.7273 19.6189 25.1305 17.1697 30.836 17.1697C37.2422 17.1697 40.3952 19.4148 40.7956 24.3132C40.7956 24.4663 40.7456 24.6194 40.6455 24.7725C40.5454 24.8745 40.3952 24.9766 40.2451 24.9766H37.5925C37.3422 24.9766 37.092 24.7725 37.042 24.5173C36.4414 21.7109 34.8899 20.7925 30.786 20.7925C26.1815 20.7925 25.631 22.4253 25.631 23.6499C25.631 25.1296 26.2817 25.5889 32.4876 26.4053C38.6435 27.2217 41.5463 28.3953 41.5463 32.7835C41.5463 37.2737 37.8928 39.8249 31.5868 39.8249Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_196_514">
                      <rect
                        width="49.28"
                        height="56"
                        fill="black"
                        transform="translate(0.653809)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              {contextData.language === "EN" ? (
                <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                  Learning...
                </span>
              ) : (
                <span className="font-DanaDemiBold text-center text-lg group-hover:text-white">
                  در حال یادگیری
                </span>
              )}
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col group justify-center w-full h-full py-6 md:py-9 px-6 border-2 rounded border-solid border-rose-600 hover:bg-black hover:border-black transition-all"
            >
              <div className="mx-auto mb-4 md:mb-8 block group-hover:hidden">
                <svg
                  width="57"
                  height="56"
                  viewBox="0 0 57 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_512)">
                    <path
                      d="M54.249 0H3.49902C2.04928 0 0.874023 1.17525 0.874023 2.625V53.375C0.874023 54.8247 2.04928 56 3.49902 56H54.249C55.6988 56 56.874 54.8247 56.874 53.375V2.625C56.874 1.17525 55.6988 0 54.249 0Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M33.3637 43.5173V49.6536C34.3579 50.1646 35.5336 50.5483 36.8911 50.8038C38.2485 51.0597 39.6792 51.1875 41.1832 51.1875C42.6489 51.1875 44.0414 51.0471 45.3603 50.7658C46.6798 50.4844 47.8361 50.0211 48.8306 49.3754C49.8246 48.7296 50.6116 47.8861 51.1918 46.844C51.7715 45.8023 52.0615 44.5143 52.0615 42.9803C52.0615 41.8681 51.8957 40.8934 51.5645 40.056C51.2329 39.2187 50.7551 38.4741 50.1304 37.8221C49.5061 37.1701 48.7571 36.5852 47.8843 36.0675C47.011 35.5498 46.0266 35.0608 44.9303 34.6006C44.1274 34.2682 43.4072 33.9454 42.77 33.6322C42.1327 33.319 41.591 32.9994 41.1449 32.6734C40.6988 32.3474 40.3547 32.0023 40.1125 31.6379C39.8704 31.2736 39.7493 30.8613 39.7493 30.4011C39.7493 29.9792 39.8576 29.5989 40.0743 29.2601C40.291 28.9214 40.5969 28.6305 40.992 28.3876C41.3871 28.1448 41.8714 27.9562 42.445 27.822C43.0185 27.6877 43.6558 27.6206 44.3568 27.6206C44.8668 27.6206 45.405 27.659 45.9724 27.7357C46.5394 27.8124 47.1099 27.9306 47.6835 28.0904C48.257 28.2502 48.8144 28.4515 49.3565 28.6944C49.8981 28.9373 50.3981 29.2186 50.8571 29.5382V23.8047C49.9265 23.4467 48.9102 23.1815 47.8077 23.0089C46.7052 22.8363 45.4404 22.75 44.0127 22.75C42.5597 22.75 41.1832 22.9066 39.8831 23.2198C38.5831 23.533 37.4391 24.022 36.4513 24.6867C35.4636 25.3515 34.6829 26.1984 34.1094 27.2275C33.5358 28.2566 33.249 29.487 33.249 30.9188C33.249 32.7469 33.7748 34.3065 34.8263 35.5977C35.8778 36.8889 37.4742 37.9819 39.6154 38.8767C40.4567 39.2219 41.2405 39.5607 41.967 39.893C42.6935 40.2254 43.3212 40.5706 43.8502 40.9285C44.3791 41.2865 44.7964 41.6764 45.1022 42.0982C45.4085 42.5201 45.5611 42.9995 45.5611 43.5364C45.5611 43.9329 45.4658 44.3004 45.2746 44.639C45.0834 44.9776 44.7933 45.2716 44.4046 45.521C44.0159 45.7704 43.5315 45.9655 42.9516 46.1059C42.3717 46.2464 41.693 46.3168 40.9155 46.3168C39.5899 46.3168 38.2772 46.0836 36.9771 45.6168C35.6771 45.1504 34.4726 44.4504 33.3637 43.5173ZM23.0564 28.2425H31.0615V23.1875H8.74902V28.2425H16.715V50.75H23.0564V28.2425Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_196_512">
                      <rect
                        width="56"
                        height="56"
                        fill="white"
                        transform="translate(0.874023)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="mx-auto mb-4 md:mb-8 hidden group-hover:block">
                <svg
                  width="57"
                  height="56"
                  viewBox="0 0 57 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_196_512)">
                    <path
                      d="M54.249 0H3.49902C2.04928 0 0.874023 1.17525 0.874023 2.625V53.375C0.874023 54.8247 2.04928 56 3.49902 56H54.249C55.6988 56 56.874 54.8247 56.874 53.375V2.625C56.874 1.17525 55.6988 0 54.249 0Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M33.3637 43.5173V49.6536C34.3579 50.1646 35.5336 50.5483 36.8911 50.8038C38.2485 51.0597 39.6792 51.1875 41.1832 51.1875C42.6489 51.1875 44.0414 51.0471 45.3603 50.7658C46.6798 50.4844 47.8361 50.0211 48.8306 49.3754C49.8246 48.7296 50.6116 47.8861 51.1918 46.844C51.7715 45.8023 52.0615 44.5143 52.0615 42.9803C52.0615 41.8681 51.8957 40.8934 51.5645 40.056C51.2329 39.2187 50.7551 38.4741 50.1304 37.8221C49.5061 37.1701 48.7571 36.5852 47.8843 36.0675C47.011 35.5498 46.0266 35.0608 44.9303 34.6006C44.1274 34.2682 43.4072 33.9454 42.77 33.6322C42.1327 33.319 41.591 32.9994 41.1449 32.6734C40.6988 32.3474 40.3547 32.0023 40.1125 31.6379C39.8704 31.2736 39.7493 30.8613 39.7493 30.4011C39.7493 29.9792 39.8576 29.5989 40.0743 29.2601C40.291 28.9214 40.5969 28.6305 40.992 28.3876C41.3871 28.1448 41.8714 27.9562 42.445 27.822C43.0185 27.6877 43.6558 27.6206 44.3568 27.6206C44.8668 27.6206 45.405 27.659 45.9724 27.7357C46.5394 27.8124 47.1099 27.9306 47.6835 28.0904C48.257 28.2502 48.8144 28.4515 49.3565 28.6944C49.8981 28.9373 50.3981 29.2186 50.8571 29.5382V23.8047C49.9265 23.4467 48.9102 23.1815 47.8077 23.0089C46.7052 22.8363 45.4404 22.75 44.0127 22.75C42.5597 22.75 41.1832 22.9066 39.8831 23.2198C38.5831 23.533 37.4391 24.022 36.4513 24.6867C35.4636 25.3515 34.6829 26.1984 34.1094 27.2275C33.5358 28.2566 33.249 29.487 33.249 30.9188C33.249 32.7469 33.7748 34.3065 34.8263 35.5977C35.8778 36.8889 37.4742 37.9819 39.6154 38.8767C40.4567 39.2219 41.2405 39.5607 41.967 39.893C42.6935 40.2254 43.3212 40.5706 43.8502 40.9285C44.3791 41.2865 44.7964 41.6764 45.1022 42.0982C45.4085 42.5201 45.5611 42.9995 45.5611 43.5364C45.5611 43.9329 45.4658 44.3004 45.2746 44.639C45.0834 44.9776 44.7933 45.2716 44.4046 45.521C44.0159 45.7704 43.5315 45.9655 42.9516 46.1059C42.3717 46.2464 41.693 46.3168 40.9155 46.3168C39.5899 46.3168 38.2772 46.0836 36.9771 45.6168C35.6771 45.1504 34.4726 44.4504 33.3637 43.5173ZM23.0564 28.2425H31.0615V23.1875H8.74902V28.2425H16.715V50.75H23.0564V28.2425Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_196_512">
                      <rect
                        width="56"
                        height="56"
                        fill="black"
                        transform="translate(0.874023)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              {contextData.language === "EN" ? (
                <span className="font-SoraBold text-center text-xl/6 group-hover:text-white">
                  Learning...
                </span>
              ) : (
                <span className="font-DanaDemiBold text-center text-lg group-hover:text-white">
                  در حال یادگیری
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
